import {canCallApp} from './utils.js';

document.querySelectorAll('.reto-eco-co-progress').forEach(el => {
    el.querySelector('.reto-eco-co-progress-fill').style.width = el.dataset.progress + '%';
});

window.onload = () => {
  const btn = document.querySelector('.js-reto-eco-impact');
  if (btn) {
    const values = {...btn.dataset};
    generateImg(values);
    if (canCallApp('tomaImagen')) {
      btn.classList.remove('d-none');
      btn.addEventListener('click', async () =>
          Trendier.tomaImagen(await canvas.toDataURL())
      );
    } else {
      btn.remove();
    }
  }

  const btnCo = document.querySelector('.js-reto-eco-impact-co');
  if (btnCo) {
    generateImgCo(btnCo.dataset.kg);
    if (canCallApp('tomaImagen')) {
      btnCo.classList.remove('display-none');
      const canvasCo = document.getElementById('canvas-co');
      btnCo.addEventListener('click', async () =>
          Trendier.tomaImagen(await canvasCo.toDataURL())
      );
    } else {
      btnCo.remove();
    }
  }
};

const generateImgCo = (kg) => {
  const canvas = document.getElementById('canvas-co');
  const ctx = canvas.getContext('2d');

  canvas.width = 1087;
  canvas.height = 1925;

  const background = new Image();
  background.src = '/assets/campaigns/reto-eco/share-co.png';

  background.onload = async () => {
    ctx.drawImage(background, 0, 0);
    ctx.font = 'bold 150px PublicSans';
    ctx.fillStyle = '#222935';
    ctx.textAlign = 'center';
    ctx.fillText(parseFloat(kg).toLocaleString('es-CO', { maximumFractionDigits: 2 }) + ' kg', 545, 1100);
    const img = document.getElementById('share-sample-co');
    img.src = await canvas.toDataURL();
    document.getElementById('share-skeleton-co')?.remove();
    document.getElementById('share-skeleton-co-text')?.remove();
    img.classList.remove('display-none');
  };
};

const generateImg = (values) => {
  const canvas = document.getElementById("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 1087;
  canvas.height = 1925;

  const background = new Image();
  background.src =
      `/assets/campaigns/reto-eco/share-${ values.kg > 0 ? 'single' : 'total' }.png`;

  background.onload = async () => {
      ctx.drawImage(background,0,0); 
      ctx.font = `bold 112px Urbanist`;
      ctx.fillStyle = '#84d8d4';
      ctx.textAlign = 'center';
      ctx.fillText(values.kg.toLocaleString() + ' Kg de CO2', 545, 854);
      ctx.fillText(values.km.toLocaleString() + ' Km', 530, 1370);
      document.getElementById('share-sample').src = await canvas.toDataURL();
  };
};